<script setup>
import { defineProps, defineEmits } from "vue";

const emit = defineEmits(["setActiveMenu"]);
const props = defineProps({
  activeMenu: String,
});

const setActiveOpen = (status) => {
  emit("setActiveMenu", status);
};
</script>

<template>
  <li class="nav-item" @click="setActiveOpen('utility')">
    <router-link
      to="/dashboard/utilities/dashboard"
      class="nav-link"
      :class="{ active: props.activeMenu === 'utility' }"
    >
      <font-awesome-icon class="nav-icon" :icon="['fas', 'fa-sliders-h']" />
      <p>Utilities Dashboard</p>
    </router-link>
  </li>
</template>
